import { useCallback } from 'react';

import { useChatSupportBasicFeatureGate } from '../../feature-gates/use-chat-support-basic-feature-gate';
import { OpenSierraSource, useOpenSierraInZendesk } from './open-sierra-in-zendesk';
import type { SierraHandoffVariables } from './open-sierra-in-zendesk';
import { useWwexFreightVariables } from './use-wwex-freight-variables';

export { OpenSierraSource };

type UseSupportChatResult = {
  isEnabled: boolean;
  openSupportChat: (source: OpenSierraSource, handoffVariables?: SierraHandoffVariables) => Promise<boolean>;
};

export const useSupportChat = (): UseSupportChatResult => {
  const { isFeatureEnabled } = useChatSupportBasicFeatureGate();
  const openSierraInZendesk = useOpenSierraInZendesk();
  const wwexFreightVariables = useWwexFreightVariables();

  const openSupportChat = useCallback(
    (source: OpenSierraSource, handoffVariables?: SierraHandoffVariables) =>
      openSierraInZendesk(source, { ...wwexFreightVariables, ...handoffVariables }),
    [openSierraInZendesk, wwexFreightVariables],
  );

  return {
    isEnabled: isFeatureEnabled,
    openSupportChat,
  };
};
